import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'play',
    loadChildren: () => import('./play/play.module').then( m => m.PlayPageModule)
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'mission-accepted',
    loadChildren: () => import('./mission-accepted/mission-accepted.module').then( m => m.MissionAcceptedPageModule)
  },
  {
    path: 'chapter-a/connexion-inprogress',
    loadChildren: () => import('./chapter-a/connexion-inprogress/connexion-inprogress.module').then( m => m.ConnexionInprogressPageModule)
  },
  {
    path: 'chapter-a/feelity-join',
    loadChildren: () => import('./chapter-a/feelity-join/feelity-join.module').then( m => m.FeelityJoinPageModule)
  },
  {
    path: 'chapter-a/score',
    loadChildren: () => import('./chapter-a/show-score/show-score.module').then( m => m.ShowScorePageModule)
  },
  {
    path: 'your-email',
    loadChildren: () => import('./your-email/your-email.module').then( m => m.YourEmailPageModule)
  },
  {
    path: 'next-level',
    loadChildren: () => import('./next-level/next-level.module').then( m => m.NextLevelPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
